(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('BagController', BagController);


    /** @ngInject */
    function BagController(   $window, $state, RemoveModalFactory, $localStorage, $translate, StoreService,
                              ShowcasesService, BagService, toastr, ModalFactory, paginationConstants, DOMAIN, $rootScope,
                              $uibModal, BrandService, FlyerCategoryService, FlyersService, CustomerService, flyersConstants, UserService,
                              systemConstants) {

        var vm = this;

        vm.isImmoContext = $localStorage.defaultStore.immoContext;
        vm.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MAX_XS;
        vm.hasVissibleDrawer = false;

        vm.redirectUrl = undefined;

        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage
        };

        vm.selectedSortByOption = 'lastModifiedDate';
        vm.sortOptions = paginationConstants.sortOptions[$translate.use().toLowerCase()].filter(function (type) {
            return type.value === "name" || type.value === "lastModifiedDate";
        });

        vm.loadingActionRequest = false;

        vm.selectedActions = [
            {
                value: 'REMOVE',
                translation: getTranslateKey(vm.isImmoContext, 'bag.list.selection.actions.remove'),
                actionFunc: function () {
                    return vm.removeShowcases();
                }
            }
        ];

        vm.selectionTypes = [
            {
                value: 'ALL_FROM_PAGE',
                translation: 'bag.list.selection.options.all-from-page'
            },
            {
                value: 'NONE',
                translation: 'bag.list.selection.options.none'
            }
        ];

        vm.goToBag = function(bag) {
            vm.getShowcaseURL(bag.id);
        }

        vm.getBagUrl = function(bag) {
            return BagService.getBagUrl(bag);
        }

        vm.copyUrl = function(url) {
            copyToClipboard(url).then(function() {
                toastr.success($translate.instant('bag.success.copied'));
            });
        }

        vm.goToReport = function(bag) {
            $localStorage.defaultStore.currentBagReport = bag.bagReportUrl;
            $state.go('virtual-bag-performance', {
                report: 'virtual-bag'
            });
        }

        vm.$onInit = init;

        /**
         * Load all values and filters for bags
         */
        function init() {
            vm.isLoading = true;

            loadStoreData();

            getDefaultFilter();

            vm.configurations = getConfigurationsValues();

            vm.menuActions = getMenuActions();

            vm.emptyImageUrl = getEmptyImageURL();

            loadShowcases();
        }

        function getEmptyImageURL() {
            var url = 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage;
            if (vm.isImmoContext) {
                return url + '/Catalogos.png';
            } else {
                return url + '/mala-m.png';
            }
        }

        function loadStoreData() {
            StoreService.getStore($localStorage.defaultStore.storeId).then(function(response) {
                vm.storeCategory = response.data.categoryKey;
                vm.redirectUrl = response.data.redirectURL;
            });
        }

        vm.getTranslateKey = function (baseKey) {
            return getTranslateKey(vm.isImmoContext, baseKey);
        };

        vm.filters = getInitialFilters();

        vm.brands = [];
        vm.categories = [];
        vm.customers = [];
        vm.users = [];
        vm.colors = [];
        vm.sizes = [];
        vm.tags = [];

        vm.listFilter = {
            ownerId: $localStorage.defaultStore.storeId,
        };

        vm.numberFilterSelected = 0;

        vm.totalBags = 0;
        vm.maxSize = 5;

        vm.page = 0;
        vm.numPerPage = paginationConstants.itemsPerPage;
        vm.itemsPerPageOptions = paginationConstants.itemsPerPageOptions;
        vm.currentPage = 1;
        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;

        vm.dateRangeOptions = {
            opens: 'right',
            locale: {
                applyClass: 'btn-green',
                applyLabel: $translate.instant('bag.filters.apply'),
                fromLabel: "From",
                format: "DD/MM/YYYY",
                toLabel: "To",
                cancelLabel: $translate.instant('bag.form.buttons.cancel'),
                customRangeLabel: $translate.instant('global.form.period')
            },
            ranges: {
            },
            eventHandlers: {
                'apply.daterangepicker': function (ev, picker) {
                    if(vm.dateRange.startDate === undefined || vm.dateRange.endDate === undefined) {
                        vm.dateRange = {startDate: moment().startOf("day"), endDate: moment().endOf("day")}
                    }
                    vm.listFilter.startDate = vm.dateRange.startDate;
                    vm.listFilter.endDate = vm.dateRange.endDate;
                    countSelectedFilters();
                    vm.resetPage();
                }
            }
        };
        vm.dateRange = '';

        vm.hasntStoreYet = !$localStorage.defaultStore.storeId;

        vm.isPublishing = false;

        vm.isAllSelected = false;
        vm.showcases = [];
        vm.selectedBags = [];
        vm.userHasShowcases = false;

        vm.hasNextPage = false;
        vm.busy = false;
        var SHOWCASE_PUBLISHED = "RELEASED";

        vm.bedrooms = flyersConstants.SELECT_OPTIONS.IMMO.SELECT_FIVE;

        /**
         * Prepare the brands array to be used on filters
         * @param array
         *  the brands array
         * @returns {*[]}
         *  the brands in format to be used on filters
         */
        function prepareFilterBrands(array) {
            var response = [];
            for (var i = 0; i < array.length; i++) {
                response.push({key: array[i], name: array[i]});
            }
            return response;
        }

        /**
         * Loads the default values for categories, brands, colors, sizes and customers to be used on filters
         */
        function getDefaultFilter() {

            function onSuccess (data) {

                vm.categories = formatSelectOptions(data.categories);
                vm.categories = sortListByStrAttribute(vm.categories, 'title');

                vm.brands = prepareFilterBrands(data.brands);
                vm.brands = sortListByStrAttribute(vm.brands, 'name');

                vm.colors = data.colors.sort();

                vm.sizes = data.sizes.sort();

                vm.tags = data.tags.sort();

                function onSuccessCustomer (data) {
                    vm.customers = data;
                    vm.customers = sortListByStrAttribute(vm.customers, 'fullName');
                }

                function onSuccessUser (data) {
                    vm.users = data;
                    vm.users = sortListByStrAttribute(vm.users, 'fullName');
                }

                var body = {
                    ids: data.customers
                };

                var userBody = {
                    ids: data.users
                }

                CustomerService.listAllByIds(body, onSuccessCustomer, onError);
                UserService.listAllByIds(userBody, onSuccessUser, onError);

            }

            function onError (response) {
                vm.isLoading = false;
                vm.busy = false;

                if (response.headers('X-flyerApp-alert') == 'userHasNoStore'){
                    toastr.error($translate.instant('showcases.messages.errors.noStore'));
                }
            }

            setTimeout(function() {
                var body = {
                    ownerId: $localStorage.defaultStore.storeId
                };

                if (vm.listFilter.ownerId) {
                    ShowcasesService.listBagsFiltersValues(body, onSuccess, onError);
                }

            }, 1000);

        }

        /**
         * Callback to refresh page view when page is changed.
         */
        vm.onPageChanged = function () {
            vm.deselectAllShowcases();

            var begin = ((vm.currentPage - 1) * vm.numPerPage),
                end = begin + vm.numPerPage;

            vm.startRegistry = begin + 1;
            vm.endRegistry = Math.min(end, vm.totalBags);
        }

        vm.openDatePicker = function () {
            document.getElementById('dateRangeInput').click()
        }

        /**
         * Refresh the page of bags exhibition
         */
        vm.refreshPage = function () {
            vm.page = vm.currentPage - 1;

            loadShowcases();
            vm.onPageChanged();
        }

        vm.onChangeItemsPerPage = function (newValue) {
            clearPaginationInfo();
            vm.numPerPage = newValue;
            vm.refreshPage();
        };

        vm.onSelectedSortOption = function (newValue) {
            clearPaginationInfo();
            vm.selectedSortByOption = newValue;
            vm.listFilter.sortBy = vm.selectedSortByOption.value;
            vm.listFilter.sortDirection = vm.selectedSortByOption.direction;
            vm.refreshPage();
        }

        /**
         * Resets the pagination
         */
        vm.resetPage = function () {
            clearPaginationInfo();
            vm.refreshPage();
        }

        /**
         * Loads all the bags with pagination and filtered
         */
        function loadShowcases() {
            if(vm.busy) return;
            vm.busy = true;


            var pageable = {
                page: vm.page,
                size: vm.numPerPage
            };

            if (vm.listFilter.ownerId){

                vm.listFilter.isPrimary = false;

                /**
                 * If the user hasn't a store, this script below cannot be executed
                 */

                ShowcasesService.listShowcases(vm.listFilter, pageable, onSuccess, onError);

                function onSuccess(data, headers) {
                    vm.hasNextPage = headers('X-Has-Next-Page') === "true";
                    vm.totalBags = parseInt(headers('X-Total-Count'));
                    vm.showcases = data;
                    vm.isLoading = false;
                    vm.userHasShowcases = vm.showcases.length >= 1 || vm.numberFilterSelected > 0 || vm.listFilter.name;

                    vm.showcases.forEach(function(showcase) {
                        showcase.actionsDrawerVisible = false;
                        showcase.menuDrawerVisible = false;
                    });
                    vm.busy = false;

                    loadEmptyMessages();
                }

                function onError(response) {
                    vm.isLoading = false;
                    vm.busy = false;

                    if (response.headers('X-flyerApp-alert') == 'userHasNoStore'){
                        toastr.error($translate.instant('showcases.messages.errors.noStore'));
                    }

                    loadEmptyMessages();
                }

            } else {
                vm.hasntStoreYet = true;
                vm.busy = false;
                vm.isLoading = false;
            }
        }

        vm.getEditPage = function(showcaseId) {
            $state.go('bag.edit', {
                showcaseId: showcaseId
            });
        }


        vm.updateShowcasesToRemove = function(showcaseId) {
            if (vm.selectedBags.indexOf(showcaseId) != '-1') {
                vm.selectedBags.splice(vm.selectedBags.indexOf(showcaseId), 1);
            } else {
                vm.selectedBags.push(showcaseId);
            }
        }

        vm.checkIfShowcaseSelected = function(showcaseId) {
            if (vm.selectedBags.indexOf(showcaseId) != '-1') {
                return true;
            } else {
                return false;
            }
        }

        vm.checkIsNotLoading = function() {
            return !vm.isLoading;
        }

        vm.checkIfShowcasePublished = function(showcaseStatus) {
            if (showcaseStatus) {
                return true;
            } else {
                return false;
            }
        }

        vm.publishShowcase = function(showcaseId) {
            var showcase = undefined;
            ShowcasesService.getShowcase(showcaseId).then(function (response) {
                showcase = response;
                if (!showcase || !showcase.id){
                    toastr.error($translate.instant('showcases.messages.publish.error'));
                }
                else if (!showcase.hasCover) {
                    toastr.error($translate.instant('showcases.messages.errors.blankCover'));
                    vm.isSaving = false;
                } else if (showcase.flyers.length < 1) {
                    toastr.error($translate.instant('showcases.messages.errors.blankFlyers'));
                } else if (!showcase.name) {
                    toastr.error($translate.instant('showcases.messages.errors.blankName'));
                } else {
                    vm.isPublishing = true;
                    ShowcasesService.publishShowcase(showcaseId).then(function(data) {
                        toastr.success($translate.instant('showcases.messages.publish.success'));
                        vm.isPublishing = false;

                        var url = vm.store && vm.store.redirectURL ? 
                            $window.location.protocol + '//' + vm.store.redirectURL : 
                            'http://' + $localStorage.defaultStore.storeNickname.toLowerCase() + "." + getDomainNameSufix($window, vm.store.storeType);

                        ModalFactory.openModal(null,
                            $translate.instant('showcases.messages.publish.successTitle', {
                            showcaseType: $translate.instant('global.showcaseTypes.' + showcase.userInteract) }),
                            $translate.instant('showcases.messages.publish.successSubtitle', {
                                url: url }),
                            null, $translate.instant('showcases.messages.publish.goToShowcase'),
                            'OK', function(){$window.open(url, '_blank')},
                            null, null, 'icon-ksc-showcasepublished');

                        $state.reload();
                    }, function(data) {
                        vm.isPublishing = false;
                        toastr.error($translate.instant('showcases.messages.publish.error'));
                    });
                }
            }, function (data) {

                if (data.headers("errorKey")){
                    toastr.error($translate.instant('showcases.messages.publish.errors.' + data.headers("errorKey")));
                } else {
                    toastr.error($translate.instant('showcases.messages.publish.errors.genericError'));
                }

                vm.isPublishing = false;
            });

        }

        vm.getPreviewURL = function(showcaseId) {
            if (!$localStorage.defaultStore.storeNickname){
                getStoreInfo().then(function(response) {
                    $localStorage.defaultStore.storeNickname = response.data.nickname;
                    var url = vm.store && vm.store.redirectURL ? 
                        $window.location.protocol + '//' + vm.store.redirectURL : 
                        $window.location.protocol + '//' + $localStorage.defaultStore.storeNickname + '.' + getDomainNameSufix($window, vm.store.storeType);
                    $window.open(url + '/preview/' + showcaseId, '_blank');
                });
            } else {
                var url = vm.store && vm.store.redirectURL ? 
                    $window.location.protocol + '//' + vm.store.redirectURL : 
                    $window.location.protocol + '//' + $localStorage.defaultStore.storeNickname + '.' + getDomainNameSufix($window, vm.store ? vm.store.storeType : $localStorage.defaultStore.storeType);
                $window.open(url + '/preview/' + showcaseId, '_blank');
            }

        }

        vm.getShowcaseURL = function(idBag) {
            if (!$localStorage.defaultStore.storeNickname) {
                getStoreInfo().then(function(response) {
                    $localStorage.defaultStore.storeNickname = response.data.nickname;
                    var url = vm.store && vm.store.redirectURL ? 
                        $window.location.protocol + '//' + vm.store.redirectURL : 
                        $window.location.protocol + '//' + $localStorage.defaultStore.storeNickname + '.' + getDomainNameSufix($window, vm.store.storeType);
                    $window.open(url + '/bag/' + idBag, '_blank');
                });
            } else {
                var url = vm.store && vm.store.redirectURL ? 
                    $window.location.protocol + '//' + vm.store.redirectURL : 
                    $window.location.protocol + '//' + $localStorage.defaultStore.storeNickname + '.' + getDomainNameSufix($window, vm.store ? vm.store.storeType : $localStorage.defaultStore.storeType);
                $window.open(url + '/bag/' + idBag, '_blank');
            }

        }

        vm.generateTabloid = function(showkase) {
            ShowcasesService.getShowcase(showkase.id).then(function (response) {
                showkase = response;
                if (!showkase.hasCover) {
                    toastr.error($translate.instant('showcases.messages.errors.blankCover'));
                    vm.isSaving = false;
                } else if (showkase.flyers.length < 1) {
                    toastr.warning($translate.instant(vm.getTranslateKey('bag.error.no-products')));
                } else if (!showkase.name) {
                    toastr.error($translate.instant('showcases.messages.errors.blankName'));
                } else {
                    vm.isPrinting = true;
                    buildMessageGeneratedTabloid(showkase);
                    $rootScope.$emit('waiting-generates-tabloid');
                    ShowcasesService.generateTabloid({
                        showcaseId: Number(showkase.id) || undefined,
                        storeId: ( $localStorage.defaultStore ? $localStorage.defaultStore.storeId + "" : undefined) || undefined,
                        flyers: []
                    }).then(succesPrint, errorPrint);
                }
            })
        }

        function buildMessageGeneratedTabloid(showkase) {
            ModalFactory.openModal(null,
                vm.getTranslateKey('bag.info.preparing-bag'),
                null, null, 'OK', null, 'close',null, null, null,
                'showcases.messages.tabloid.ifNotDownloaded', 'showcases.messages.tabloid.clickHere',
            function(callback){
                ShowcasesService.generateTabloid({
                    showcaseId: Number(showkase.id) || undefined,
                    storeId: ( $localStorage.defaultStore ? $localStorage.defaultStore.storeId + "" : undefined) || undefined,
                    flyers: []
                }).then(succesPrint, errorPrint);
            }, 'width: 40%;', getEmptyImageURL());
        }

        function succesPrint(res) {
            if (res.headers["content-disposition"]){
                var filename = res.headers["content-disposition"].match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1];
                var mimeType = res.headers["content-type"];
                filename = filename.replace(/['"]/g, '');
                saveByteArray([res.data], filename, mimeType);
            } else {
                toastr.error($translate.instant('showcases.messages.tabloid.error.erroByGenerateCatalog'));
            }

            vm.isPrinting = false;
            $rootScope.$emit('finish-generate-tabloid');
        }

        function errorPrint(response) {
            vm.isPrinting = false;
            $rootScope.$emit('finish-generate-tabloid');
            toastr.error($translate.instant('showcases.messages.tabloid.error.erroByGenerateCatalog'));
        }

        function getStoreInfo() {
            return StoreService.getStore($localStorage.defaultStore.storeId);
        }

        getStoreInfo().then(function(response) {
            $localStorage.defaultStore.storeType = response.data.storeType;
            $localStorage.defaultStore.storeNickname = response.data.nickname;
            vm.store = response.data;
        });

        /**
         * Verify if all showcases are selected
         * @returns {*|boolean} True if all showcases are selected
         */
        vm.isShowAllSelected = function () {
            vm.isAllSelected = vm.showcases.length > 0 && vm.selectedBags.length === vm.showcases.length;
            return vm.isAllSelected;
        }

        /**
         * Select or deselect all bags.
         * If all bags are selected, deselect all the bags
         * If not all bags are selected, then selects all the bags
         */
        vm.changeSelectionOfAllShowcases = function () {
            if (vm.isAllSelected) {
                vm.deselectAllShowcases();
            } else {
                vm.selectAllShowcases();
            }

        }

        /**
         * Select all bags
         */
        vm.selectAllShowcases = function () {
            var showcasesToRemoveTemp = [];
            for (var i = 0; i < vm.showcases.length; i++) {
                showcasesToRemoveTemp.push(vm.showcases[i].id)
            }
            vm.selectedBags = showcasesToRemoveTemp;
            vm.isAllSelected = true;
        }

        /**
         * Deselect all bags
         */
        vm.deselectAllShowcases = function () {
            vm.selectedBags = [];
            vm.isAllSelected = false;
        }

        /**
         * Opens a modal to filter bags
         */
        vm.openFiltersModal = function () {
            vm.filtersConversationModal = $uibModal.open({
                templateUrl: 'app/admin/bag/modal-filter-bag/bag-filter-modal.html',
                controller: 'FiltersBagsController',
                windowClass: 'modal-side-menu',
                backdrop: 'static',
                controllerAs: 'vm',
                keyboard: false,
                resolve: {
                    options: function () {
                        return {
                            brands: vm.brands,
                            configurations: vm.configurations,
                            customers: vm.customers,
                            users: vm.users,
                            tags: vm.tags,

                            categories: vm.categories,
                            colors: vm.colors,
                            sizes: vm.sizes,

                            bedrooms: vm.bedrooms,
                            bathrooms: vm.bathrooms,
                            parkingSpots: vm.parkingSpots,

                            itemsPerPageOptions: vm.itemsPerPageOptions,
                            sortOptions: vm.sortOptions,
                            numPerPage: vm.numPerPage,
                            selectedSort: vm.selectedSortByOption
                        }
                    },
                    filters: function () {
                        return vm.filters
                    },
                    list: function () {
                        return vm.listFilter
                    }
                },
            }).result.then(function (response) {
                if (response) {
                    // Refresh the page with selected filters
                    vm.numberFilterSelected = response.totalFilters;
                    vm.filters = response.selectedFilters;
                    vm.listFilter = response.listFilter;

                    if (response.numPerPage && response.numPerPage !== vm.numPerPage) {
                        vm.numPerPage = response.numPerPage;
                    }
                    clearPaginationInfo();

                    if (response.sortSelected && response.sortSelected !== vm.selectedSortByOption) {
                        vm.selectedSortByOption = response.sortSelected;
                        vm.listFilter.sortBy = vm.selectedSortByOption.value;
                        vm.listFilter.sortDirection = vm.selectedSortByOption.direction;
                    }
                    vm.refreshPage();
                }
            });
        }

        /**
         * Removes from database the selected bags
         */
        vm.removeShowcases = function() {
            vm.loadingActionRequest = true;
            if (vm.selectedBags.length >= 1) {
                RemoveModalFactory.deleteItem(vm.selectedBags.length).then(function(data) {
                    ShowcasesService.deleteShowcases(vm.selectedBags).then(function(data) {
                        vm.loadingActionRequest = false;
                        toastr.success($translate.instant(vm.getTranslateKey('bag.success.removed')));
                        vm.showcases = [];
                        vm.selectedBags = [];
                        vm.resetPage();
                    }, function(data) {
                        vm.loadingActionRequest = false;
                        toastr.error($translate.instant('showcases.messages.remove.error'));
                    });
                }, function() {
                    vm.loadingActionRequest = false;
                });
            } else {
                vm.loadingActionRequest = false;
                toastr.error($translate.instant('showcases.messages.remove.noItens'));
            }
        }

        vm.getImageSrc = function (showcaseId) {
            return "content/images/templates/"+ showcaseId +".png"
        }

        vm.loadFilter = function (filterType, listKey, singleKey, valueKey) {
            if (vm.filters[filterType].length > 0) {
                var formatedList = vm.filters[filterType].map(function (item) {
                    return item[valueKey];
                });

                vm.listFilter[listKey] = formatedList;

                if (singleKey && formatedList.length > 0) {
                    vm.listFilter[singleKey] = formatedList[0];
                }
            } else {
                delete vm.listFilter[listKey];
                if (singleKey) {
                    delete vm.listFilter[singleKey];
                }
            }
            countSelectedFilters();
            vm.resetPage();
        }

        vm.loadConfigurationsFilter = function () {
            if (vm.filters.configurations.length > 0) {
                var configurations = vm.filters.configurations.map(function (item) {
                    return item.code;
                });

                if (configurations.length > 0) {
                    if (configurations.includes('basic')) {
                        vm.listFilter.isBasic = true;
                    } else {
                        delete vm.listFilter.isBasic;
                    }
                    if (configurations.includes('launch')) {
                        vm.listFilter.isLaunch = true;
                    } else {
                        delete vm.listFilter.isLaunch;
                    }
                    if (configurations.includes('delivered')) {
                        vm.listFilter.isDelivered = true;
                    } else {
                        delete vm.listFilter.isDelivered;
                    }
                }
            } else {
                delete vm.listFilter.isBasic;
                delete vm.listFilter.isLaunch;
                delete vm.listFilter.isDelivered;
            }

            countSelectedFilters();
            vm.resetPage();
        }

        vm.loadFilterRange = function () {
            if (vm.filters.minValue && vm.filters.maxValue) {
                vm.listFilter.minValue = vm.filters.minValue;
                vm.listFilter.maxValue = vm.filters.maxValue;
            } else {
                delete vm.listFilter.minValue;
                delete vm.listFilter.maxValue;
            }
            clearPaginationInfo();
            countSelectedFilters();
            vm.resetPage();
        }

        vm.clearFilters = function () {
            vm.filters = getInitialFilters();

            vm.listFilter = {
                ownerId: $localStorage.defaultStore.storeId
            };

            countSelectedFilters();
            vm.resetPage();
        }

        vm.isIndeterminate = function () {
            return vm.selectedBags.length > 0 && !vm.isAllSelected;
        }

        vm.selectItemsBy = function (type) {
            if (type === 'ALL_FROM_PAGE') {
                vm.showcases.forEach(function (showcase) {
                    if (vm.selectedBags.indexOf(showcase.id) === -1) {
                        vm.selectedBags.push(showcase.id);
                    }
                });
            } else if (type === 'NONE') {
                vm.selectedBags = [];
            }
            countSelectedFilters();
        }

        vm.existsSelectedItems = function () {
            return vm.selectedBags && vm.selectedBags.length > 0;
        }

        vm.openActionsDrawer = function (showcase) {
            if (!showcase.actionsDrawerVisible) {
                showcase.actionsDrawerVisible = true;
            }
            vm.calculateDrawerVisibility();
        }

        vm.closeActionsDrawer = function (showcase) {
            if (showcase.actionsDrawerVisible) {
                showcase.actionsDrawerVisible = false;
            }
            vm.calculateDrawerVisibility();
        }

        vm.editBag = function (showcase) {
            if (showcase && showcase.id) {
                vm.getEditPage(showcase.id);
            }
        }

        vm.deleteBag = function (showcase) {
            if (showcase && showcase.id) {
                vm.loadingActionRequest = true;
                var isLastShowcase = vm.showcases.length === 1;
                RemoveModalFactory.deleteItem(1).then(function(data) {
                    ShowcasesService.deleteShowcases([showcase.id]).then(function(data) {
                        vm.loadingActionRequest = false;
                        toastr.success($translate.instant(vm.getTranslateKey('bag.success.removed')));
                        vm.resetPage();
                    }, function(data) {
                        vm.loadingActionRequest = false;
                        toastr.error($translate.instant('showcases.messages.remove.error'));
                    });
                }, function() {
                    vm.loadingActionRequest = false;
                });
            }
        }

        vm.sendToWhatsApp = function (bag) {
            BagService.sendToWhatsApp(bag);
        }

        vm.isIndeterminate = function () {
            return vm.selectedBags.length > 0 && !vm.isAllSelected;
        }

        vm.selectItemsBy = function (type) {
            if (type === 'ALL_FROM_PAGE') {
                vm.showcases.forEach(function (showcase) {
                    if (vm.selectedBags.indexOf(showcase.id) === -1) {
                        vm.selectedBags.push(showcase.id);
                    }
                });
            } else if (type === 'NONE') {
                vm.selectedBags = [];
            }
            countSelectedFilters();
        }

        vm.existsSelectedItems = function () {
            return vm.selectedBags && vm.selectedBags.length > 0;
        }

        vm.toggleActionsDrawer = function (showcase) {
            showcase.actionsDrawerVisible = !showcase.actionsDrawerVisible;
        }

        vm.calculateDrawerVisibility = function () {
            vm.hasVisibleDrawer = vm.showcases.some(function (s) { return s.actionsDrawerVisible; });
        }

        function getConfigurationsValues() {
            if (vm.isImmoContext) {
                return flyersConstants.SELECT_OPTIONS.IMMO.CONFIGURATIONS;
            } else {
                return flyersConstants.SELECT_OPTIONS.RETAIL.CONFIGURATIONS;
            }
        }

        function clearPaginationInfo() {
            // Turn to 0 the page to give right page on pageable
            vm.page = 0;
            vm.currentPage = 1;
            vm.paginationOptions = {
                page: vm.currentPage - 1,
                size: vm.numPerPage
            };
        }

        function countSelectedFilters() {
            vm.numberFilterSelected =
                // Common
                (angular.isArray(vm.filters.customers) ? vm.filters.customers.length : 0) +
                (angular.isArray(vm.filters.brands) ? vm.filters.brands.length : 0) +
                (angular.isArray(vm.filters.configurations) ? vm.filters.configurations.length : 0) +
                (angular.isArray(vm.filters.tags) ? vm.filters.tags.length : 0) +
                (vm.filters.bagSinceDate && vm.filters.bagUntilDate ? 1 : 0) +

                // Retail
                (angular.isArray(vm.filters.categories) ? vm.filters.categories.length : 0) +
                (angular.isArray(vm.filters.colors) ? vm.filters.colors.length : 0) +
                (angular.isArray(vm.filters.sizes) ? vm.filters.sizes.length : 0) +
                (angular.isArray(vm.filters.genders) ? vm.filters.genders.length : 0) +

                // Immo
                (angular.isArray(vm.filters.region) ? vm.filters.region.length : 0) +
                (angular.isArray(vm.filters.bedrooms) ? vm.filters.bedrooms.length : 0) +
                (angular.isArray(vm.filters.bathrooms) ? vm.filters.bathrooms.length : 0) +
                (angular.isArray(vm.filters.parkingSpots) ? vm.filters.parkingSpots.length : 0) +
                (vm.filters.minValue && vm.filters.maxValue ? 1 : 0) +
                (vm.filters.minMeters && vm.filters.maxMeters ? 1 : 0) +
                (vm.filters.sinceDate && vm.filters.untilDate ? 1 : 0);
        }

        function loadEmptyMessages() {
            var noBagsRegistered = (!vm.listFilter.name || vm.listFilter.name.length === 0) && vm.numberFilterSelected === 0;
            if (noBagsRegistered) {
                vm.emptyTitle = $translate.instant(getTranslateKey(vm.isImmoContext, 'bag.list.empty.no-bags.title'));
                vm.emptyDescription = $translate.instant(getTranslateKey(vm.isImmoContext, 'bag.list.empty.no-bags.description'));
            } else {
                vm.emptyTitle = $translate.instant(getTranslateKey(vm.isImmoContext, 'bag.list.empty.filtered.title'));
                vm.emptyDescription = $translate.instant(getTranslateKey(vm.isImmoContext, 'bag.list.empty.filtered.description'));
            }
        }

        function getMenuActions() {
            return [
                {
                    name: 'edit',
                    icon: "icon-ksc-pen-to-square-light",
                    label: 'bag.actions.edit',
                    method: vm.editBag
                },
                {
                    name: 'delete',
                    icon: "icon-ksc-trash-light",
                    label: 'bag.actions.delete',
                    method: vm.deleteBag
                }
            ];
        }

        function getInitialFilters() {
            return {
                // Common
                customers: [],
                brands: [],
                configurations: [],
                tags: [],
                hasInventory : !vm.isImmoContext,
                sortSelected: {
                    value: 'lastModifiedDate',
                    direction: 'desc',
                },
                bagSinceDate: null,
                bagUntilDate: null,

                // Retail
                categories: [],
                colors: [],
                sizes: [],
                genders: [],

                // Immo
                region: [],
                bedrooms: [],
                bathrooms: [],
                parkingSpots: [],
                minValue: null,
                maxValue: null,
                minMeters: null,
                maxMeters: null,
                sinceDate: null,
                untilDate: null,
            }
        }
    }
})();
